import { render, staticRenderFns } from "./HeaderDeItem.vue?vue&type=template&id=62935b04&scoped=true"
import script from "./HeaderDeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderDeItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HeaderDeItem.vue?vue&type=style&index=0&id=62935b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62935b04",
  null
  
)

export default component.exports